import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Input,
  Output,
} from '@angular/core';
import { Router } from '@angular/router';
import { ENVIRONMENT_CONFIG } from '@core/config-angular';
import { EnvironmentConfig } from '@core/config-models';
import type { JssNavItem } from '@core/jss-models';
import { JssRouteBuilderService } from '@core/jss-routing';
import { logout, type RouteItem } from '@core/navigation-store';
import type { State } from '@innogy/utils-state';
import { Store } from '@ngrx/store';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgClass } from '@angular/common';

import { SidebarNavComponent } from '../../sidebar-nav/sidebar-nav.component';
import { NavigationServiceButtonComponent } from '@core/navigation-ui/navigation-service-button';

@Component({
  selector: 'wl-header-tools',
  templateUrl: './header-tools.component.html',
  styleUrls: [
    './header-tools.component.essent.scss',
    './header-tools.component.ed.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CSCaptureDirective,
    AutomationIdDirective,
    FaIconComponent,
    SidebarNavComponent,
    NgClass,
    NavigationServiceButtonComponent,
  ],
})
export class HeaderToolsComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() language?: string;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() navItems: RouteItem[] = [];

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() title?: string;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() isLoggedIn?: boolean;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() hasMultipleAccounts?: boolean;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() loginButtonText?: string;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() loginUrl?: string;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() loginUrlLabel?: string;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() fullName?: string;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() logOutButtonText?: string;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() logoutEndpointUrl?: string;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() switchAccountButtonText?: string;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() switchAccountEndpointUrl?: string;

  @Output()
  navItemClick = new EventEmitter<JssNavItem>();

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() showCategories?: boolean;

  constructor(
    @Inject(ENVIRONMENT_CONFIG)
    private readonly config: EnvironmentConfig,
    private readonly urlBuilder: JssRouteBuilderService,
    readonly router: Router,
    private readonly store$: Store<State>
  ) {}

  getRouteUrl(navItem: JssNavItem, language: string) {
    return this.urlBuilder.createRouteData(navItem, language);
  }

  logout(): void {
    this.store$.dispatch(
      logout({
        payload: {
          redirect_url: this.logoutEndpointUrl as string,
          chatEnabled: this.config.iAdvizeChatbot.enabled,
        },
      })
    );
  }
}
